import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PromptChain, SelectedFilters } from 'rio-models';

export const promptChainsActions = createActionGroup({
  source: 'PromptChains',
  events: {
    clearAllPromptChains: emptyProps(),

    loadChains: emptyProps(),
    loadChainsSuccess: props<{ chains: PromptChain[] }>(),
    loadChainsFailure: emptyProps(),

    loadFilteredChainsWithEmptyFilters: props<{ filters: undefined }>(),
    loadFilteredChains: props<{ filters: SelectedFilters }>(),
    loadFilteredChainsSuccess: props<{ chains: PromptChain[] }>(),
    loadFilteredChainsFailure: emptyProps(),

    deletePromptChainFromList: props<{ chainId: string }>(),
    openDeletePromptChainDialogFromList: props<{ chainId: string }>(),
    deletePromptChainFromDetails: props<{ chainId: string }>(),
    openDeletePromptChainDialogFromDetails: props<{ chainId: string }>(),
    deletePromptChainSuccess: props<{ chainId: string }>(),
    deletePromptChainFailure: emptyProps(),
  },
});
